<template>
  <div class="baseEdit">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            {{ this.$t('paymentListAdd.paymentInfo.title') }}
          </div>
        </template>
        <div class="collapse-content">
          <PaymentInfo
            :canEdit="canEdit"
            :invoiceLineAmount="invoiceLineAmount"
            @calcInvoiceLine="calcInvoiceLine"
            @paymentMethodChange="paymentMethodChange"
            ref="feeInfo"
          />
        </div>
      </el-collapse-item>
      <el-tabs v-model="activeNameTab" type="border-card" class="addCooperationTabs">
        <!-- 行信息 -->
        <el-tab-pane name="first" :label="$t('paymentListAdd.invoiceLine.title1')">
          <invoiceLine
            :departmentList="departmentList"
            :sourceType="sourceType"
            :canEdit="canEdit"
            :isHnFlag="isHnFlag"
            :paymentMethod="paymentMethod"
            @getInvoiceLineAmount="getInvoiceLineAmount"
            ref="invoiceLineInfo"
          />
        </el-tab-pane>
        <!-- 票据信息 -->
        <el-tab-pane name="second" :label="$t('paymentListAdd.invoiceLine.title2')">
          <BillInfo
            :canEdit="canEdit"
            :invoiceLineAmount="invoiceLineAmount"
            :paymentMethod="paymentMethod"
            :currencyCode="currencyCode"
            :paymentCompanyCode="paymentCompanyCode"
            ref="billInfo"
          />
        </el-tab-pane>
        <!-- 会计凭证 -->
        <el-tab-pane name="voucherTab" :label="$t('paymentListAdd.invoiceLine.title4')">
          <voucher
            ref="voucher"
            :voucherList="voucherList"
            @reverseInfo="reverseInfo"
            @postInfo="postInfo"
          ></voucher>
        </el-tab-pane>
      </el-tabs>
      <el-collapse-item name="4">
        <template slot="title">
          <div class="collapse-title-pre"><span></span>附件</div>
        </template>
        <div class="collapse-content">
          <upload
            ref="upload"
            :isShow="false"
            defaultPath="scm/payment"
            :tableData="attachmentList"
          />
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="fixed-bottom-btnList">
      <el-button
        v-if="this.$route.name.indexOf('Details') != -1"
        type="primary"
        @click="canEdit = !canEdit"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042916243774136']"
        :disabled="['Saved', 'Error'].indexOf(paymentStatus) == -1"
        >{{ this.$t('functionBtn.editToggle') }}</el-button
      >
      <el-button
        :disabled="!canEdit || (paymentStatus && ['Saved', 'Error'].indexOf(paymentStatus) == -1)"
        type="primary"
        @click="save('PAYMENT_UPDATE')"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042916250385949']"
        >{{ this.$t('functionBtn.save') }}</el-button
      >
      <el-button
        :disabled="['Saved', 'Error'].indexOf(paymentStatus) == -1"
        type="primary"
        @click="save('CONFIRM_PAYMENT')"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042916253113119']"
        >{{ this.$t('paymentListAdd.btns.payment') }}</el-button
      >
      <el-button
        :disabled="
          paymentStatus != 'Paid' ||
          isDirectConnectionToBank == '1' ||
          accountingStatus != 'notgenerate'
        "
        type="primary"
        @click="doWithdraw()"
        v-hasPermi="['2021042916255715485']"
        class="fixed-bottom-btn"
        >撤回</el-button
      >
      <!-- 生成凭证 -->
      <el-button
        :disabled="
          paymentStatus != 'Paid' ||
          ['notgenerate', 'generated', 'postError'].indexOf(accountingStatus) == -1
        "
        type="primary"
        @click="handleAccountEntry()"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042916261652247']"
        >{{ this.$t('functionBtn.generateCredentials') }}</el-button
      >
      <el-button
        :disabled="
          paymentStatus != 'Paid' || ['generated', 'postError'].indexOf(accountingStatus) == -1
        "
        type="primary"
        @click="doSyncVoucherForEntityData()"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042916264331188']"
        >过账凭证</el-button
      >
      <el-button
        :disabled="paymentStatus != 'Paid'"
        type="primary"
        @click="doReverseAccountEntryOther()"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042916270372318']"
        >{{ this.$t('functionBtn.writeOff') }}</el-button
      >
      <el-button
        :disabled="['Paying'].indexOf(paymentStatus) == -1"
        type="primary"
        @click="confirmPayResult"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042916272333007']"
        >支付结果查询</el-button
      >
    </div>
  </div>
</template>
<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import PaymentInfo from './components/paymentInfo';
  import invoiceLine from './components/invoiceLine';
  import BillInfo from './components/billInfo';
  import API from '@/api/financeCenter/payment';
  import qs from 'qs';
  import voucherMixins from '@/common/mixins/voucher.js';
  import Upload from '@/components/upload';
  // import { MessageBox } from 'element-ui';

  export default {
    mixins: [voucherMixins],
    components: {
      PaymentInfo,
      invoiceLine,
      BillInfo,
      // MessageBox,
      Upload,
    },
    name: 'baseEdit',
    data() {
      return {
        attachmentList: [],
        canEdit: true,
        paymentCompanyCode: null, // 公司代码
        paymentStatus: null, // 单据状态
        currencyCode: null, // 币种
        accountingStatus: null, // 入账状态
        paymentMethod: null, // 付款方式
        invoiceLineAmount: {},
        activeNames: ['1', '2', '4'],
        sourceType: null, // 来源
        voucherFlag: 'AE_AP_PAYMENTS', //凭证标识
        departmentList: [],
        isDirectConnectionToBank: null, // 银企直连标识
        //校验关联结算批次
        checkSettleParams: {
          associationType: '5',
          associationNoList: [],
        },
        isHnFlag: false,
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    mounted() {
      let [apiName, params] = [null, null];
      if (this.$route.name.indexOf('Add') != -1) {
        // 获取付款申请数据
        if (this.$route.query.flag == 'letterOfCredit') {
          // 获取信用证信息
          [apiName, params] = [
            'CREATE_PAYMENT_FOR_CREDIT',
            qs.stringify({ id: this.$route.query.ids }),
          ];
        } else {
          [apiName, params] = [
            'PAYMENT_CREATE_DETAIL',
            qs.stringify({ ids: this.$route.query.ids }),
          ];
        }
      } else {
        // 获取申请单数据
        [apiName, params] = ['PAYMENT_DETAIL', qs.stringify({ id: this.$route.query.id })];
        if (this.$route.name.indexOf('Details') != -1) {
          this.canEdit = false;
        }
      }
      this.getData(apiName, params);
    },
    methods: {
      //

      setIIsHnFlag(companyCode) {
        // 切换到海宁
        this.$baseRequest
          .getSysConfigByCompany({
            code: 'PAYMENT_APPLY_HN',
            companyCode,
          })
          .then((res) => {
            this.isHnFlag = res == 'Y' || false;
          });
      },

      importDetail(allDetail) {
        this.paymentCompanyCode = allDetail.paymentCompanyCode;
        let feeInfo = this.$refs.feeInfo.baseData; // 付款单
        Object.keys(feeInfo).forEach((item) => {
          if (item.indexOf('is') == 0) {
            feeInfo[item] = allDetail[item] == '1';
          } else {
            feeInfo[item] = allDetail[item];
          }
        });
        // Object.keys(feeInfo).map((item) => {
        //   if (item.indexOf("is") == 0) {
        //     feeInfo[item] = allDetail[item] == "1";
        //   } else {
        //     feeInfo[item] = allDetail[item];
        //   }
        // });
        this.$refs.feeInfo.getBankInfo(feeInfo.receiveCompanyNo, this.paymentCompanyCode);
        feeInfo.currencyName = feeInfo.currencyName
          ? feeInfo.currencyName
          : this.$baseRequest.getDictValueByType('all_currency', feeInfo.currencyCode);
        if (!feeInfo.id) {
          // 付款申请(付款日期默认当前日期，制单人默认当前人, 汇率日期默认制单日期)
          feeInfo.paymentCreateDate = new Date();
          feeInfo.paymentCreatePersonName = this.userInfo.userName;
          feeInfo.paymentCreatePersonNo = this.userInfo.userCode;
          // feeInfo.exchangeRateDate = feeInfo.paymentCreateDate;
        }
        [
          'paymentMethod',
          'paymentStatus',
          'currencyCode',
          'sourceType',
          'accountingStatus',
          'isDirectConnectionToBank',
        ].map((item) => {
          return (this[item] = allDetail[item]);
        }); // 付款方式、单据状态、币种、来源、入账状态
        this.$refs.invoiceLineInfo.tableData = allDetail.fundPaymentDetailList; // 行信息-表格
        this.$refs.billInfo.tableData = allDetail.fundPaymentBillList; // 票据
        this.getDepartment(allDetail.paymentCompanyCode);

        this.setIIsHnFlag(allDetail.paymentCompanyCode);
        // 获取凭证ID 获取凭证列表
        this.entityDataId = allDetail.id;
        if (this.entityDataId) this.getAccountEntry();
        this.checkSettleParams.associationNoList = [allDetail.paymentNum];
      },
      // 获取详情数据
      async getData(
        apiName = 'PAYMENT_DETAIL',
        params = qs.stringify({ id: this.$route.query.id })
      ) {
        this.loading.startLoading();
        let res = await this.$axios.post(API[apiName], params);
        this.loading.endLoading();
        if (res) {
          if (res.data.code == 0) {
            this.importDetail(res.data.data);
            this.attachmentList = res.data.data.returnAttachmentList || [];
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        }
      },
      async getDepartment(companyCode) {
        // 获取部门数据
        if (companyCode) {
          let res = await this.$baseRequest.getDepartment(companyCode);
          if (res) {
            this.departmentList = res;
            if (this.departmentList.length == 0) {
              this.tips('noDepartment', 'error');
            }
          }
        } else {
          this.departmentList = [];
        }
      },
      // 行信息汇率及本位币
      calcInvoiceLine(exchangeRate) {
        this.$refs.invoiceLineInfo.tableData.map((item) => {
          item.exchangeRate = exchangeRate;
          item.paymentAccountedAmount = this.calcLocalAmount(exchangeRate, item.paymentAmount);
          item.actualPaymentAccountedAmount = this.calcLocalAmount(
            exchangeRate,
            item.actualPaymentAmount
          );
        });
        this.$refs.invoiceLineInfo.updateData();
      },
      // 计算本币
      calcLocalAmount(exchangeRate, originAmount) {
        if (exchangeRate && originAmount) {
          return this.$cal.calCommon(originAmount, exchangeRate, '*', 'amount');
        } else {
          return null;
        }
      },
      // 获取行金额总和
      getInvoiceLineAmount(val) {
        this.invoiceLineAmount = val;
      },
      // 付款方式赋值
      paymentMethodChange(val) {
        this.paymentMethod = val;
        this.$refs.billInfo.tableData = [];
      },
      async save(apiName) {
        // 保存
        this.loading.startLoading();
        let feeInfo = await this.$refs.feeInfo.exportChildData(); // 付款单信息
        if (feeInfo.exchangeRate == 0) {
          this.$message({
            showClose: true,
            type: 'error',
            message: '汇率不能为0',
          });
          this.loading.endLoading();
          return;
        }
        let fundPaymentDetailList = await this.$refs.invoiceLineInfo.exportChildData(); // 行信息
        let fundPaymentBillList = await this.$refs.billInfo.exportChildData(); // 票据
        if (feeInfo && fundPaymentDetailList && fundPaymentBillList) {
          feeInfo.actualPaymentAmount = 0;
          fundPaymentDetailList.map((item) => {
            if (item.isDiscount === '1') {
              feeInfo.actualPaymentAmount = this.$cal.calCommon(
                feeInfo.actualPaymentAmount,
                item.actualPaymentAmount,
                '+'
              );
            } else {
              feeInfo.actualPaymentAmount = this.$cal.calCommon(
                feeInfo.actualPaymentAmount,
                item.paymentAmount,
                '+'
              );
            }
          });
          feeInfo.actualPaymentAccountedAmount = this.$cal.calCommon(
            feeInfo.actualPaymentAmount,
            feeInfo.exchangeRate,
            '*'
          );
          let params = {
            ...feeInfo,
            fundPaymentDetailList,
            fundPaymentBillList,
          };
          params = this.$baseRequest.assignObj(params);
          if (apiName == 'CONFIRM_PAYMENT') {
            this.beforePay(params, apiName);
          } else {
            this.saveData(params, apiName);
          }
        } else {
          this.loading.endLoading();
        }
      },
      // 撤回
      async doWithdraw() {
        let params = {
          //撤回所需参数
          id: this.$route.query.id,
          //检查关联结算批次所需参数
          ...this.checkSettleParams,
        };
        this.$baseRequest
          .doWithdrawCommon(API.WITHDRAW, params)
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                showClose: true,
                type: 'success',
                message: res.msg,
              });
              this.getData();
            } else {
              this.$message({ showClose: true, type: 'error', message: res.msg });
            }
          })
          .catch((e) => {
            console.log(e);
          });
      },
      async saveData(params, apiName) {
        let res = await this.$axios.post(API[apiName], params);
        this.loading.endLoading();
        if (res) {
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
            if (apiName == 'CONFIRM_PAYMENT') {
              this.returnPath();
            } else {
              this.importDetail(res.data.data);
            }
          } else {
            // 确认付款失败后刷新数据
            if (apiName == 'CONFIRM_PAYMENT') {
              if (res.data.data && res.data.data.id) {
                [apiName, params] = ['PAYMENT_DETAIL', qs.stringify({ id: res.data.data.id })];
                this.getData(apiName, params);
              }
            }
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
      // 付款前校验
      async beforePay(params, apiName) {
        let res = await this.$axios.post(API.BEFORE_PAY, params);
        this.loading.endLoading();
        if (res.data.code == 0) {
          this.saveData(params, apiName);
        } else if (res.data.code == 9) {
          this.$confirmAction(res.data.msg, '确认付款')
            .then(() => {
              this.saveData(params, apiName);
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: '取消付款',
              });
            });
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: res.data.msg,
          });
        }
      },

      // 支付结果查询
      confirmPayResult() {
        this.loading.startLoading();
        this.$axios
          .post(API.PAY_RESULT, {
            id: this.$route.query.id,
          })
          .then((res) => {
            this.loading.endLoading();
            if (res.data.code === 0) {
              this.MessageBox.alert(res.data.msg, '支付结果', {
                confirmButtonText: '确定',
                callback: () => {
                  this.getData('PAYMENT_DETAIL', qs.stringify({ id: res.data.data.id }));
                },
              });
            } else {
              this.$alert(res.data.msg);
            }
          })
          .catch(() => this.loading.endLoading());
      },

      // 点击冲销按钮
      doReverseAccountEntryOther() {
        this.$confirmAction('确认冲销', '本单据已支付，是否要确认冲销？')
          .then(() => {
            this.doReverseAccountEntry();
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('message.cancelled'),
            });
          });
      },
      returnPath() {
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: { keepAlive: true },
          },
          toPath: {
            path: '/payment/paymentList',
            name: 'paymentList',
            meta: { keepAlive: false },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      tips(info, type) {
        // 提示
        this.$message({
          showClose: true,
          message: this.$t(`paymentList.message.${info}`),
          type: type,
        });
      },
    },
  };
</script>
